export const SearchTags = {
    SearchInput: 'atlantis-search-input'
};

export class AtlSearchEvent extends CustomEvent<{ query: string }> {
    static EVENT_NAME = 'atlantis-search';

    constructor(query: string) {
        super(AtlSearchEvent.EVENT_NAME, { detail: { query }, bubbles: true, composed: true });
    }
}